module.exports = __webpack_public_path__ + "static/service-provide-badge-4562714002e50e4f2ec18714064fd585.png";